import { motion } from 'framer-motion';
import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { useTheme } from './ThemeContext';
function Footer() {
  const { isDarkMode } = useTheme();
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.5 }}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
      }}
      className={`bg-[#235191] dark:bg-zinc-800 lg:px-28 px-10 md:px-20 mt-16 ${isDarkMode ? 'dark' : ''}`}>
      <div className="lg:flex items-center md:flex-col lg:flex-row justify-between">
        <div className='flex items-center gap-1'>
          <Icon />
          <div className="logo text-white font-bold mt-3 text-4xl max-md:max-w-full">EntryHub</div>
        </div>


        <div className="text-white text-xl mt-8 font-semibold">
          <p>Follow us</p>
          <div className='flex gap-4'>
            <a href="https://wa.me/923493476657">
              <FaWhatsapp className='text-gray-500 dark:bg-[#25D366] dark:text-white w-8 h-8 p-1 bg-white rounded-md' />
            </a>
            <Link to="https://www.linkedin.com/in/govind-kumar-a96a65272/" target="_blank" >
              <FaLinkedinIn className='text-gray-500 dark:bg-[#0077b5] dark:text-white w-8 h-8 p-1 bg-white rounded-md' />
            </Link>
            <Link to="https://www.facebook.com/profile.php?id=100032309142621" target="_blank" >
              <FaFacebookF className='text-gray-500 w-8 dark:bg-blue-500 h-8 p-1 bg-white dark:text-white rounded-md' />
            </Link>
            <Link to="https://www.instagram.com/sunnysyntax/" target="_blank">
              <FaInstagram className='text-gray-500 w-8 h-8 p-1 dark:bg-gradient-to-br from-[#6382fc] via-[#cd486b] to-[#d2ee00]  bg-white dark:text-white rounded-md' />
            </Link>
          </div>

        </div>

        <div className='mt-8'>
          <div className="text-white text-xl  font-semibold ">Contacts</div>
          <div className="text-white text-opacity-50  ">
            Email : engrgovindkumar@gmail.com
            <br />
            Whatsapp No : +92 349 3476657
          </div>
        </div>
      </div>

      <div className='text-white text-center mt-8 mb-3'>
        All Copyrights reserved &copy; { new Date().getFullYear()}
      </div>
    </motion.div>
  )
}

export default Footer